/** @file texelToScreen: the screen point of a texel centre of a placed part (the forward quad frame). */
import type { PlacedPart, Point } from './sheetTypes';

/** The centre of texel (`tx`, `ty`) of the unflipped tile, on screen through the quad's affine frame. */
export function texelToScreen(part: Pick<PlacedPart, 'quad' | 'size' | 'flip'>, tx: number, ty: number): Point {
  const [tl, tr, , bl] = part.quad;
  const [w, h] = part.size;
  const u = (part.flip ? w - tx - 0.5 : tx + 0.5) / w;
  const v = (ty + 0.5) / h;
  return [tl[0] + (tr[0] - tl[0]) * u + (bl[0] - tl[0]) * v, tl[1] + (tr[1] - tl[1]) * u + (bl[1] - tl[1]) * v];
}
